// extracted by mini-css-extract-plugin
module.exports =  {"checkbox-wrapper":"e2ff468f85--checkbox-wrapper--ovQyh","focused":"e2ff468f85--focused--VEc4h"};